<div class="app-section-div" [ngClass]="type === 'overlayPopup' ? 'app-section-nomination-div' : ''">
  <ng-content></ng-content>
</div>
